import React from "react";
import { LayoutAdminCafe } from "../../../layout/layout_cafe";
import StatsPage from "../../barista/stats/stats_page";

export function AdminStats() {
    return (
        <LayoutAdminCafe>
            <StatsPage />
        </LayoutAdminCafe>
    );
}
